import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_i2w3l6b8: FaireBrandEntity = {
  token: "b_i2w3l6b8",
  type: "brand",
  name: "Rock Bottom Soap",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/8893d86ec7259afa0e3efbcfb51a2638f6703a5d0dc1d5f80f3f03690915a72f/1537219496.jpg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1bac2ad397c8b4312a084194c2937c0d247e7114cbc05f7f038e1a828806bf92.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/8893d86ec7259afa0e3efbcfb51a2638f6703a5d0dc1d5f80f3f03690915a72f/1537219496.jpg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1bac2ad397c8b4312a084194c2937c0d247e7114cbc05f7f038e1a828806bf92.jpeg",
  location: "London, KY, USA",
  minimumOrderDollars: 173,
  rating: 4.9,
  reviewCount: 581,
  isTopShop: true,
  isInsider: true,
  description:
    "Our farm history began with horses. In fact, the dairy goats were bought initially to support the foals in case a mare had inadequate milk. We milked lots of milk from our two first goats.  We froze the milk in case any baby animal in our neighborhood needed it, no one needed it. So then the problem become, what to do with the milk? I got my nerve up and tried my first batch of soap. When I felt how great my skin felt after the first shower I was hooked.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:39.695Z",
    importedBy: "entity-db-cli",
  },
};
